/**
 * 页面垂直平滑滚动到指定滚动高度
 * @description 页面垂直平滑滚动到指定滚动高度
 */
const scrollSmoothTo = function (position: number): void {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback: FrameRequestCallback): number {
      return setTimeout(callback, 17);
    };
  }
  // 当前滚动高度
  let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  // 滚动step方法
  const step = function (): void {
    // 距离目标滚动距离
    const distance = position - scrollTop;
    // 目标滚动位置
    scrollTop = scrollTop + distance / 5;
    if (Math.abs(distance) < 1) {
      window.scrollTo(0, position);
    } else {
      window.scrollTo(0, scrollTop);
      requestAnimationFrame(step);
    }
  };
  step();
};

export function isSupportedSmooth(): boolean {
  return (window.CSS && window.CSS.supports("scroll-behavior", "smooth")) || false;
}

export function scrollToYSmooth(y: number): void {
  if (typeof y !== "number" || isNaN(Number(y))) {
    throw new Error("argument is invalid number.");
  }
  if (isSupportedSmooth()) {
    window.scroll({ left: 0, top: y, behavior: "smooth" });
  } else {
    scrollSmoothTo(y);
  }
}
